<template>
  <div class="home">
    <div class="centers">
      <div class="boxs1">
        <div class="boxs">
          <div class="box1l"><img src="../assets/home1.png" alt=""></div>
          <div class="box1r">
            <h3>MPODI 病虫神算子</h3>
            <p class="rps">基于生态型的农作物病虫害预测模型与开发平台</p>
            <div class="btns hovers">
              <p @click="toschanpin()">了解更多 →</p>
            </div>
          </div>
        </div>

      </div>
      <div class="boxs2">
        <p class="titles">关于我们：</p>
        <div class="boxs">
         
          <div class="box2r">
            <p><span>“</span>结合科学技术提供创新的解决方案，改变我们管理和防控农业和家庭害虫的方式。我们的目标是创造能够改善人类健康和保护环境的新技术、新产品</p>
          </div>
          <div class="box2l">
            
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'Home',
  components: {
    // HelloWorld
  },
  data() {
    return {}
  },
  methods: {
    toschanpin(){
      this.$router.push({ path: "/Chanpin" })
    }
  },
  created() { },
  mounted() { }
}
</script>
<style scoped>
.boxs {
  /* border: 1px solid red; */
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 0;
}

.boxs1,
.boxs2 {
  width: 85%;
  margin: auto;
  margin-top: 5rem;
  margin-bottom: 2rem;
}

.box1l {
  width: 40%;
  /* border: 1px solid red; */
}

.box1l img {
  width: 100%;
}

.box1r {
  width: 50%;
  /* border: 1px solid red; */
}

.box1r h3 {
  font-size: 1.9rem;
  color: #9c9c9c;
  font-weight: bold;
  letter-spacing: 5px;
}

.box1r p {
  font-size: 1rem;
  color: #2180D1;
  line-height: 1.6;
}

.rps {
  width: 60%;
  margin-bottom: 1.2rem;
  margin-top: 1.5rem;
}

.btns {
  border: 1px solid #2180D1;
  display: inline-block;
  padding: 0.3rem 1rem;
}

.btns p {
  font-size: 0.6rem;
}

.box2l {
  width: 50%;
  height: 50vh;
  background: #eee;
}

.box2r {
  /* background: yellow; */
  /* border: 1px solid; */
  width: 45%;
}
.box2r p span{
  color: #2180D1;
  font-size: 3rem;
}
.box2r p{
  font-size: 1.4rem;
  text-indent: 1em;
  line-height:1.4;
  color: #3b3c3c;
  letter-spacing: 0.1em;
}
.titles{
  font-size: 1.8rem;
}
</style>
